// Copy and figures for /product/landed-cost. The Sambar and the five-car entry are a real
// Aug 2026 RoRo import with names removed; every total below reconciles (see the 7501 table).
export const DOC_CHIPS = [
    {
        k: '請',
        name: 'Agent invoice'
    },
    {
        k: '証',
        name: 'Export certificate'
    },
    {
        k: '船',
        name: 'Bill of lading'
    },
    {
        k: '通',
        name: 'CBP 3461'
    },
    {
        k: '税',
        name: 'CBP 7501'
    },
    {
        k: '港',
        name: 'Wharfage receipt'
    },
    {
        k: '環',
        name: 'EPA 3520-1'
    },
    {
        k: '登',
        name: 'DOT HS-7'
    }
];
export const SAMBAR_LINES = [
    {
        label: 'Vehicle (hammer)',
        note: '¥655,000',
        usd: '$4,032.84',
        doc: 'Agent invoice'
    },
    {
        label: 'Agent service fee',
        note: '¥100,000 · flat',
        usd: '$615.70',
        doc: 'Agent invoice'
    },
    {
        label: 'Auction fee',
        note: '¥20,000',
        usd: '$123.14',
        doc: 'Agent invoice'
    },
    {
        label: 'JP inland transport',
        note: '¥25,800',
        usd: '$158.85',
        doc: 'Agent invoice'
    },
    {
        label: 'Insurance',
        note: '¥12,000',
        usd: '$73.88',
        doc: 'Agent invoice'
    },
    {
        label: 'Ocean freight (RoRo)',
        note: '¥171,104 · ¥24,500 + 9.0 m³ × $99.35 + $25 doc @ ¥159.50',
        usd: '$1,053.49',
        doc: 'Agent invoice'
    },
    {
        label: 'Duty 25%',
        note: 'on $4,033 entered value',
        usd: '$1,008.25',
        doc: 'CBP 7501'
    },
    {
        label: 'MPF 0.3464%',
        note: 'share of entry MPF',
        usd: '$13.97',
        doc: 'CBP 7501'
    },
    {
        label: 'HMF 0.125%',
        note: '',
        usd: '$5.04',
        doc: 'CBP 7501'
    }
];
export const ENTRY = [
    {
        car: '2001 Subaru Sambar',
        frame: 'TT2-104086',
        note: 'truck',
        ev: '$4,033',
        rate: '25%',
        duty: '$1,008.25',
        mpf: '$13.97',
        hmf: '$5.04',
        total: '$1,027.26'
    },
    {
        car: '2000 Honda Acty',
        frame: 'HA7-1200635',
        note: 'truck',
        ev: '$3,325',
        rate: '25%',
        duty: '$831.25',
        mpf: '$11.52',
        hmf: '$4.16',
        total: '$846.93'
    },
    {
        car: '1998 Honda Street',
        frame: 'HH3-2368277',
        note: 'van',
        ev: '$2,771',
        rate: '15%',
        duty: '$415.65',
        mpf: '$9.60',
        hmf: '$3.46',
        total: '$428.71'
    },
    {
        car: '2000 Daihatsu Hijet',
        frame: 'S210P-0063430',
        note: 'truck',
        ev: '$2,832',
        rate: '25%',
        duty: '$708.00',
        mpf: '$9.81',
        hmf: '$3.54',
        total: '$721.35'
    },
    {
        car: '2001 Subaru Sambar',
        frame: 'TT2-105194',
        note: 'truck',
        ev: '$3,940',
        rate: '25%',
        duty: '$985.00',
        mpf: '$13.65',
        hmf: '$4.93',
        total: '$1,003.58'
    }
];
// What review raises before a document's lines are booked (the cost ledger's review warnings).
export const FLAGS = [
    {
        sev: 'high',
        label: 'High',
        text: 'Duty shows up on the 7501 and again on the broker invoice. Book it from one of them.'
    },
    {
        sev: 'check',
        label: 'Check',
        text: 'MPF and HMF are only stated for the whole entry, so this car’s share is prorated by its entered value. Confirm before you apply.'
    },
    {
        sev: 'check',
        label: 'Check',
        text: 'A hand-entered purchase line overlaps the invoice’s hammer price.'
    },
    {
        sev: 'note',
        label: 'Note',
        text: 'The invoice ¥/$ rate varies (159.50 / 162.60 / 163.80), so FX is stored for each document rather than for the shipment.'
    },
    {
        sev: 'note',
        label: 'Note',
        text: 'One agent invoice has no exchange rate. Add its Wise transfer.'
    },
    {
        sev: 'note',
        label: 'Note',
        text: 'Line 1 of the 7501 carries this car’s frame number (TT2-104086), so only that line is booked here.'
    }
];
